export const isNullOrUndefinedOrEmpty = (value) => {
  return value === null || value === undefined || value === "";
};
